var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "backage",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "package-shipping-and-delivery-svgrepo-com",
    transform: "translate(2.049 -18.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(0 21.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M19.073,34.6h-.142a2.481,2.481,0,0,0,.142-.828V23.82a2.488,2.488,0,0,0-2.488-2.487H6.634A2.487,2.487,0,0,0,4.147,23.82v.824s0,0,0,.007h-.83A2.487,2.487,0,0,0,.829,27.137v6.636a2.482,2.482,0,0,0,.142.828H.829A.829.829,0,0,0,0,35.431v3.317a.829.829,0,0,0,.829.829H19.073a.829.829,0,0,0,.829-.829V35.431A.829.829,0,0,0,19.073,34.6ZM6.634,22.992h9.952a.829.829,0,0,1,.829.828v9.953a.829.829,0,0,1-.829.828H14.1V27.137a2.488,2.488,0,0,0-2.487-2.487h-.83a.829.829,0,0,0-.829-.829H5.805A.828.828,0,0,1,6.634,22.992ZM7,27.277l-1.2.8v-2.6H9.122v2.6l-1.2-.8a.83.83,0,0,0-.92,0Zm-4.516,6.5V27.137a.828.828,0,0,1,.828-.828h.83v3.317a.83.83,0,0,0,.855.83.821.821,0,0,0,.434-.14l2.028-1.352,2.028,1.352a.821.821,0,0,0,.434.14.83.83,0,0,0,.855-.83V26.309h.829a.829.829,0,0,1,.829.828V34.6H3.316A.828.828,0,0,1,2.488,33.773Zm15.756,4.146H1.659V36.26H18.244Z",
    transform: "translate(0 -21.333)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackage);
export default __webpack_public_path__ + "static/media/backage.84e8bd8dfb710325ca86bc2cc0f5f76c.svg";
export { ForwardRef as ReactComponent };